/* Current Nostalgia - search that reads the words (v94). Shared part, on every page.
   Shopify's storefront search is loose: "supreme hoodie l" returns every Supreme piece plus other
   brands' hoodies, sizes ignored. So a search is read first: a brand name becomes the Brand filter,
   a garment word the Product type filter (the last one wins: "crew socks" is socks), and a size
   ("L", "size 32", "W32", "sneakers 9.5") is matched on the tiles by assets/cn-search-page.js.
   The words it knows live in snippets/cn-search-meta. Search forms and plain search links go
   straight to the read search; typing adds it ("Supreme · Hoodies · Size L") and matching brands
   to the suggestions. cn=1 marks a read search, cn=0 the plain one, cn_q what was typed. */
(function () {
  if (window.__cnSearch) return;
  window.__cnSearch = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- reading a search ---------- */
  /* accents off ("Stüssy" = "stussy"): combining marks U+0300-U+036F after NFD */
  var MARKS = new RegExp('[' + String.fromCharCode(0x300) + '-' + String.fromCharCode(0x36f) + ']', 'g');
  function norm(s) {
    s = String(s || '');
    try { s = s.normalize('NFD').replace(MARKS, ''); } catch (e) {}
    return s.toLowerCase().replace(/[’'`]/g, '').replace(/&/g, ' and ');
  }
  function words(s) {
    return norm(s).replace(/[^a-z0-9/.\-]+/g, ' ').replace(/\.(?!\d)/g, ' ').split(/\s+/).filter(Boolean);
  }

  var TYPE_LABEL = {};
  function typeLabel(list) {
    getMeta();
    var l = list.map(norm);
    if (l.indexOf('cap') > -1 && l.indexOf('beanie') > -1) return 'Hats';
    if (l.indexOf('sneakers') > -1 || l.indexOf('footwear') > -1) return 'Footwear';
    if (l.length > 3 && l.indexOf('shirt') > -1) return 'Shirts';
    return TYPE_LABEL[l[0]] || list[0];
  }

  var SIZE = {
    xxs: 'xxs', xs: 'xs', xsmall: 'xs', 'x-small': 'xs', 'x small': 'xs', 'extra small': 'xs',
    s: 's', sm: 's', small: 's', m: 'm', md: 'm', med: 'm', medium: 'm', l: 'l', lg: 'l', large: 'l',
    xl: 'xl', xlarge: 'xl', 'x-large': 'xl', 'x large': 'xl', 'extra large': 'xl',
    xxl: 'xxl', '2xl': 'xxl', xxlarge: 'xxl', 'xx-large': 'xxl', 'xx large': 'xxl', '2x': 'xxl',
    xxxl: 'xxxl', '3xl': 'xxxl', 'xxx-large': 'xxxl', '3x': 'xxxl',
    os: 'os', osfa: 'os', 'one size': 'os', 'o/s': 'os'
  };
  /* these only count as a size at the end of the search or after "size" / "in":
     "large box logo tee" is not a size L search */
  var LOOSE = { s: 1, sm: 1, small: 1, m: 1, md: 1, med: 1, medium: 1, l: 1, lg: 1, large: 1, os: 1, '2x': 1, '3x': 1 };
  var SIZE_LEAD = { size: 1, sz: 1, sizes: 1, 'in': 1, us: 1 };

  var meta = null;
  function getMeta() {
    if (meta) return meta;
    var m = { vendors: [], types: {}, typePhrases: [] };
    var j = {};
    try { j = JSON.parse((document.getElementById('cn-search-meta') || {}).textContent || '{}'); } catch (e) {}
    var vendors = j.vendors || [], alias = j.alias || {}, partner = (j.partner || []).map(norm);
    TYPE_LABEL = j.typeLabel || {};
    (j.types || []).forEach(function (t) { if (t) m.types[norm(t)] = t; });
    var seen = {};
    function add(key, name) {
      var w = words(key);
      if (!w.length || seen[w.join(' ')]) return;
      seen[w.join(' ')] = true;
      m.vendors.push({ w: w, name: name, partner: partner.indexOf(norm(name)) > -1 });
    }
    vendors.forEach(function (v) {
      if (!v) return;
      add(v, v);
      var w = words(v);
      if (w.length > 1) add(w.join(''), v);
    });
    Object.keys(alias).forEach(function (a) { if (vendors.indexOf(alias[a]) > -1) add(a, alias[a]); });
    m.vendors.sort(function (a, b) { return b.w.length - a.w.length; });
    (j.typeWords || []).forEach(function (row) {
      var vals = (row[1] || []).filter(function (t) { return m.types[t]; }).map(function (t) { return m.types[t]; });
      if (!vals.length) return;
      (row[0] || []).forEach(function (p) { m.typePhrases.push({ w: words(p), vals: vals }); });
    });
    m.typePhrases.sort(function (a, b) { return b.w.length - a.w.length; });
    meta = m;
    return m;
  }

  function at(tokens, i, w) {
    if (i + w.length > tokens.length) return false;
    for (var k = 0; k < w.length; k++) if (tokens[i + k] !== w[k]) return false;
    return true;
  }
  function sizeAt(tokens, i) {
    var t = tokens[i], prev = tokens[i - 1], n = tokens.length, m;
    var lead = prev && SIZE_LEAD[prev];
    if ((lead || prev === 'us') && /^\d{1,2}(\.5)?$/.test(t)) return { len: 1, size: String(parseFloat(t)) };
    if ((m = t.match(/^w(\d{2})$/)) || (m = t.match(/^(\d{2})w$/)) || (m = t.match(/^(\d{2})x\d{2}$/))) return { len: 1, size: m[1] };
    if ((m = t.match(/^us(\d{1,2}(\.5)?)$/))) return { len: 1, size: String(parseFloat(m[1])) };
    for (var len = 2; len >= 1; len--) {
      if (i + len > n) continue;
      var p = tokens.slice(i, i + len).join(' ');
      if (!SIZE[p]) continue;
      if (LOOSE[p] && !(i + len === n || lead)) continue;
      return { len: len, size: SIZE[p] };
    }
    return null;
  }

  /* -> null when the search has no brand, garment or size in it */
  function parse(q) {
    var original = String(q || '').replace(/\s+/g, ' ').trim();
    if (!original || original.length > 120) return null;
    var tokens = words(original);
    if (!tokens.length) return null;
    var m = getMeta();
    var parts = [];
    var i = 0;
    while (i < tokens.length) {
      var hit = null;
      for (var v = 0; v < m.vendors.length && !hit; v++) {
        if (at(tokens, i, m.vendors[v].w)) hit = { kind: 'vendor', len: m.vendors[v].w.length, vendor: m.vendors[v] };
      }
      if (!hit) { var s = sizeAt(tokens, i); if (s) hit = { kind: 'size', len: s.len, size: s.size }; }
      if (!hit) {
        for (var t = 0; t < m.typePhrases.length && !hit; t++) {
          if (at(tokens, i, m.typePhrases[t].w)) hit = { kind: 'type', len: m.typePhrases[t].w.length, vals: m.typePhrases[t].vals };
        }
      }
      if (!hit) hit = { kind: 'word', len: 1 };
      hit.text = tokens.slice(i, i + hit.len).join(' ');
      parts.push(hit);
      i += hit.len;
    }
    var vendor = null, types = null, size = '';
    parts.forEach(function (p) {
      if (p.kind === 'vendor' && !p.vendor.partner && !vendor) { vendor = p; p.used = true; }
      if (p.kind === 'size') { size = p.size; p.used = true; }
    });
    for (var k = parts.length - 1; k >= 0; k--) {
      if (parts[k].kind === 'type') { types = parts[k]; types.used = true; break; }
    }
    /* a bare number at the end is a size when the garment says what kind: a waist for
       pants and shorts ("shorts 32"), a shoe size for footwear ("sneakers 9.5") */
    var last = parts[parts.length - 1];
    if (!size && types && last && last.kind === 'word' && /^\d{1,2}(\.5)?$/.test(last.text)) {
      var num = parseFloat(last.text);
      var tv = types.vals.map(norm).join(' ');
      if ((/\b(pants|shorts)\b/.test(tv) && num >= 24 && num <= 44) ||
          (/\b(sneakers|footwear|slides)\b/.test(tv) && num >= 3 && num <= 16)) {
        size = String(num);
        last.used = true;
      }
    }
    if (!vendor && !types && !size) return null;
    var rest = [];
    parts.forEach(function (p, idx) {
      if (p.used) return;
      /* "size" / "in" in front of a size go with it */
      if (p.kind === 'word' && SIZE_LEAD[p.text] && parts[idx + 1] && parts[idx + 1].kind === 'size') return;
      rest.push(p.text);
    });
    var out = {
      original: original,
      vendor: vendor ? vendor.vendor.name : '',
      types: types ? types.vals : [],
      typeText: types ? types.text : '',
      size: size,
      rest: rest.join(' ')
    };
    out.q = out.rest || out.vendor || out.typeText;
    if (!out.q) return null;
    return out;
  }
  window.cnParseSearch = parse;

  function buildUrl(p) {
    var u = new URLSearchParams();
    u.set('q', p.q);
    u.set('type', 'product');
    u.set('options[prefix]', 'last');
    if (p.vendor) u.append('filter.p.vendor', p.vendor);
    (p.types || []).forEach(function (t) { u.append('filter.p.product_type', t); });
    if (p.size) u.set('cn_size', p.size);
    u.set('cn', '1');
    u.set('cn_q', p.original);
    return ROOT + 'search?' + u.toString();
  }
  function plainUrl(q) {
    return ROOT + 'search?q=' + encodeURIComponent(q) + '&options%5Bprefix%5D=last&cn=0';
  }
  function sizeLabel(s) {
    if (s === 'os') return 'One Size';
    return /^\d/.test(s) ? s : s.toUpperCase();
  }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* ---------- search forms go straight to the read search ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (e.defaultPrevented || !f || f.tagName !== 'FORM') return;
    var action;
    try { action = new URL(f.getAttribute('action') || '', location.href).pathname; } catch (err) { return; }
    if (!/\/search\/?$/.test(action)) return;
    var input = f.querySelector('input[name="q"]');
    var p = input && parse(input.value);
    if (!p) return;
    e.preventDefault();
    location.assign(buildUrl(p));
  });

  /* plain search links (popular searches, Shopify's query suggestions) too - saves a redirect */
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('a[href*="search?"]');
    if (!a || a.target === '_blank') return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin || !/\/search\/?$/.test(u.pathname) || u.searchParams.has('cn')) return;
    var hasFilter = false;
    u.searchParams.forEach(function (v, k) { if (k.indexOf('filter.') === 0) hasFilter = true; });
    var p = !hasFilter && parse(u.searchParams.get('q'));
    if (!p) return;
    e.preventDefault();
    location.assign(buildUrl(p));
  });

  /* ---------- suggestions while typing ---------- */
  function suggestItem(id, href, html) {
    return '<li id="' + id + '" class="predictive-search__list-item cn-ps" role="option" aria-selected="false">' +
      '<a href="' + esc(href) + '" class="predictive-search__item link link--text" tabindex="-1">' +
      '<div class="predictive-search__item-content predictive-search__item-content--centered">' +
      '<p class="predictive-search__item-heading h5">' + html + '</p></div></a></li>';
  }
  function enhanceSuggestions(ps) {
    var list = ps.querySelector('#predictive-search-results-queries-list');
    var wrap = ps.querySelector('#predictive-search-results-groups-wrapper');
    var input = ps.querySelector('input[name="q"]');
    if (!input || (!list && !wrap)) return;
    var holder = list || wrap;
    var q = input.value.trim();
    if (holder.getAttribute('data-cn-for') === q) return;
    holder.setAttribute('data-cn-for', q);
    if (list) list.querySelectorAll('.cn-ps').forEach(function (li) { li.remove(); });
    var heads = list ? Array.prototype.map.call(list.querySelectorAll('.predictive-search__item-heading'), function (el) { return norm(el.textContent).trim(); }) : [];
    var html = '';
    var p = parse(q);
    if (p && (p.vendor || p.types.length)) {
      var have0 = heads;
      var only = p.vendor && !p.types.length && !p.size && !p.rest;
      if (!(only && have0.indexOf(norm(p.vendor)) > -1)) {
        var bits = [];
        if (p.vendor) bits.push(esc(p.vendor));
        if (p.types.length) bits.push(esc(typeLabel(p.types)));
        if (p.size) bits.push('Size ' + esc(sizeLabel(p.size)));
        var extra = p.rest ? ' <span class="cn-ps__q">“' + esc(p.rest) + '”</span>' : '';
        if (only) extra = ' <span class="cn-ps__tag">Brand</span>';
        html += suggestItem('predictive-search-option-cn-read', buildUrl(p), bits.join(' <span class="cn-ps__sep">·</span> ') + extra);
      }
    }
    /* brands that start with what's typed, unless Shopify already suggests them */
    var nq = norm(q);
    if (nq.length >= 2 && !p) {
      var have = heads;
      var shown = {};
      getMeta().vendors.forEach(function (v) {
        var name = v.name, n = norm(name);
        if (shown[name] || Object.keys(shown).length >= 2 || have.indexOf(n) > -1) return;
        if (n.indexOf(nq) === 0 || n.replace(/\s+/g, '').indexOf(nq.replace(/\s+/g, '')) === 0) {
          shown[name] = true;
          var url = v.partner ? ROOT + 'search?q=' + encodeURIComponent(name) + '&options%5Bprefix%5D=last&cn=0'
            : buildUrl({ original: name, q: name, vendor: name, types: [], size: '' });
          html += suggestItem('predictive-search-option-cn-brand-' + Object.keys(shown).length, url, esc(name) + ' <span class="cn-ps__tag">Brand</span>');
        }
      });
    }
    if (!html) return;
    /* Shopify had no suggestions of its own: add the Suggestions column it would have drawn */
    if (!list) {
      wrap.insertAdjacentHTML('afterbegin', '<div class="predictive-search__result-group cn-ps-group"><div>' +
        '<h2 id="predictive-search-queries" class="predictive-search__heading text-body caption-with-letter-spacing">Suggestions</h2>' +
        '<ul id="predictive-search-results-queries-list" class="predictive-search__results-list list-unstyled" role="group" aria-labelledby="predictive-search-queries"></ul></div></div>');
      wrap.classList.remove('predictive-search__results-groups-wrapper--no-suggestions');
      list = wrap.querySelector('#predictive-search-results-queries-list');
      list.setAttribute('data-cn-for', q);
    }
    list.insertAdjacentHTML('afterbegin', html);
  }
  function watchSuggestions() {
    document.querySelectorAll('predictive-search').forEach(function (ps) {
      if (ps.__cnWatch || !window.MutationObserver) return;
      ps.__cnWatch = true;
      var box = ps.querySelector('[data-predictive-search]');
      if (!box) return;
      new MutationObserver(function () { enhanceSuggestions(ps); }).observe(box, { childList: true, subtree: true });
    });
  }

  window.cnSearch = { parse: parse, buildUrl: buildUrl, plainUrl: plainUrl, typeLabel: typeLabel, sizeLabel: sizeLabel, norm: norm, esc: esc };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSuggestions); else watchSuggestions();
})();